module.exports = function() {
  return new Worker(__webpack_public_path__ + "c25d7e343f3d8e57c58e.worker.js");
};